module.exports = __webpack_public_path__ + "static/media/vector.58b43de8.svg";